import { Noticia, NoticiaTraduccion } from "./noticia";

export class FormPublicacionModel {
    myNoticia: Noticia;
    listaTraducciones: NoticiaTraduccion[];
}